import axios from "shared/api/axiosConfig";
 

export async function getOrCreateReferralCode(type, user){
    try{
        const response = await axios.post('/client/getOrCreateReferralCode', {user, type});
        return response.data;
    }catch (error) {
        return error;
    }
}

export async function sendSponsorshipEmail(type, email, referralCode){
    try{
        const response = await axios.post('/client/sendSponsorshipEmail', {type, email, referralCode})
        return response.data;

    }catch (error) {
        return error;
    }
}

export async function sendBroadcastEmail(){
    try{
        const response = await axios.post('/client/sendBroadcastInfo2')
        return response.data;

    }catch (error) {
        return error;
    }
}